/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AiParaphrasingResult = {
  __typename?: 'AiParaphrasingResult';
  paraphrasedText?: Maybe<Scalars['String']>;
  status: StatusType;
};

export type AiToolMutation = {
  __typename?: 'AiToolMutation';
  backChangePasswordResolver: StatusType;
  backCustomerCancelClaimFreeMonthResolver: StatusType;
  backCustomerCancelLogReasonResolver: StatusType;
  backCustomerCancelSubscriptionResolver: StatusType;
  backUpdatePersonalInfoResolver: StatusType;
  backUseWordsResolver: StatusType;
  trackFreeSmartGenResolver: StatusType;
};


export type AiToolMutationBackChangePasswordResolverArgs = {
  confirmPassword: Scalars['String'];
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
};


export type AiToolMutationBackCustomerCancelLogReasonResolverArgs = {
  cancelReasonId?: InputMaybe<Scalars['Int']>;
};


export type AiToolMutationBackCustomerCancelSubscriptionResolverArgs = {
  cancelReasonId?: InputMaybe<Scalars['Int']>;
};


export type AiToolMutationBackUpdatePersonalInfoResolverArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};


export type AiToolMutationBackUseWordsResolverArgs = {
  genChatId?: InputMaybe<Scalars['Int']>;
  toolTypeId: Scalars['Int'];
  wordsCount: Scalars['Int'];
};

export type AiToolQuery = {
  __typename?: 'AiToolQuery';
  aiTools: AiTools;
  browserExt: BrowserExt;
};

export type AiTools = {
  __typename?: 'AiTools';
  aiParaphraseText: AiParaphrasingResult;
  aiToolsSubscriptionInfo: AiToolsSubscriptionInfoType;
  aiToolsSubscriptionPrices: AiToolsPricingDataType;
  aiToolsTestingData: AiToolsTestingDataType;
  aiToolsUserPackages: AiToolsUserPackages;
  canBuyOfferAfterTrialToolsAccessV2: Scalars['Boolean'];
  canBuyOfferAnnualMinus80ToolsAccessV2: Scalars['Boolean'];
  canBuyOfferMonthlyPlanToolsAccessV2: Scalars['Boolean'];
  canShowBoughtOfferAnnualMinus80ToolsAccessV2: Scalars['Boolean'];
  passwordChangeCaptcha: PasswordChangeCaptchaType;
  trustpilotReviewCollector: TrustpilotReviewCollectorType;
  userDataAiBrainTools: UserDataAiBrainToolsType;
  userDataAiToolsAccessV2: UserDataAiToolsAccessV2Type;
};


export type AiToolsAiParaphraseTextArgs = {
  text: Scalars['String'];
};


export type AiToolsAiToolsSubscriptionPricesArgs = {
  operationType?: InputMaybe<Scalars['String']>;
  selectPackageId?: InputMaybe<Scalars['Int']>;
};


export type AiToolsUserDataAiToolsAccessV2Args = {
  currentUserUrl?: InputMaybe<Scalars['String']>;
  requestGetParams?: InputMaybe<Scalars['String']>;
};

export type AiToolsPricingDataType = {
  __typename?: 'AiToolsPricingDataType';
  defaultOperationType: Scalars['String'];
  defaultPackageId: Scalars['Int'];
  packages: Array<AiToolsPricingPackageType>;
  status?: Maybe<StatusType>;
};

export type AiToolsPricingNextPlanType = {
  __typename?: 'AiToolsPricingNextPlanType';
  name?: Maybe<Scalars['String']>;
  period?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
};

export type AiToolsPricingPackageType = {
  __typename?: 'AiToolsPricingPackageType';
  currency_code?: Maybe<Scalars['String']>;
  current_period_price?: Maybe<Scalars['String']>;
  current_price?: Maybe<Scalars['String']>;
  current_price_geo_cur?: Maybe<Scalars['String']>;
  current_price_usd_cur?: Maybe<Scalars['String']>;
  default_monthly_price?: Maybe<Scalars['String']>;
  discount_price_geo_cur?: Maybe<Scalars['String']>;
  discount_price_usd_cur?: Maybe<Scalars['String']>;
  effective_price_geo_cur?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_after_trial: Scalars['Boolean'];
  is_annual: Scalars['Boolean'];
  is_best: Scalars['Boolean'];
  is_lifetime: Scalars['Boolean'];
  is_monthly: Scalars['Boolean'];
  is_popular: Scalars['Boolean'];
  is_trial: Scalars['Boolean'];
  is_visible: Scalars['Boolean'];
  name: Scalars['String'];
  next_plan?: Maybe<AiToolsPricingNextPlanType>;
  original_monthly_price?: Maybe<Scalars['String']>;
  period: Scalars['String'];
  renewal_label?: Maybe<Scalars['String']>;
  save_label?: Maybe<Scalars['String']>;
  tip?: Maybe<Scalars['String']>;
  tip_card_form?: Maybe<Scalars['String']>;
  vat_included?: Maybe<Scalars['Boolean']>;
};

export type AiToolsSubscriptionDetailsType = {
  __typename?: 'AiToolsSubscriptionDetailsType';
  cardLast4?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isAvailableGrace: Scalars['Boolean'];
  isCancellationAvailable: Scalars['Boolean'];
  isDeactivated: Scalars['Boolean'];
  isEndingSoon: Scalars['Boolean'];
  isFreeOfCharge: Scalars['Boolean'];
  isLifetime: Scalars['Boolean'];
  isRefundRequested: Scalars['Boolean'];
  nextChargeDate?: Maybe<Scalars['String']>;
  nextPaymentAmount?: Maybe<Scalars['String']>;
  nextPaymentPeriod?: Maybe<Scalars['String']>;
  packageName: Scalars['String'];
};

export type AiToolsSubscriptionInfoType = {
  __typename?: 'AiToolsSubscriptionInfoType';
  state: AiToolsSubscriptionStateEnum;
  stats?: Maybe<AiToolsSubscriptionStatsType>;
  status: StatusType;
  subscription?: Maybe<AiToolsSubscriptionDetailsType>;
};

export type AiToolsSubscriptionPackageType = {
  __typename?: 'AiToolsSubscriptionPackageType';
  amount: Scalars['Float'];
  amountFormatted: Scalars['String'];
  amountFormatted2: Scalars['String'];
  currencyCode: Scalars['String'];
  currencySign: Scalars['String'];
  id: Scalars['Int'];
  isLifetime: Scalars['Boolean'];
  isTrial: Scalars['Boolean'];
  name: Scalars['String'];
  period: Scalars['String'];
  periodInMonth?: Maybe<Scalars['Int']>;
};

export enum AiToolsSubscriptionStateEnum {
  FailRecharge = 'FAIL_RECHARGE',
  None = 'NONE',
  NoRunning = 'NO_RUNNING',
  Running = 'RUNNING'
}

export type AiToolsSubscriptionStatsType = {
  __typename?: 'AiToolsSubscriptionStatsType';
  isPayAsYouGoMode: Scalars['Boolean'];
  totalWordsUsed: Scalars['Int'];
};

export type AiToolsTestingDataType = {
  __typename?: 'AiToolsTestingDataType';
  availableOrderCount?: Maybe<Scalars['Int']>;
  emulation?: Maybe<AiToolsTestingEmulationType>;
  status: StatusType;
  userId?: Maybe<Scalars['Int']>;
};

export type AiToolsTestingEmulationType = {
  __typename?: 'AiToolsTestingEmulationType';
  declineCode: Scalars['String'];
  nextCharge: AiToolsTestingEmulationUrlsType;
  rebillMode: AiToolsTestingEmulationUrlsType;
};

export type AiToolsTestingEmulationUrlsType = {
  __typename?: 'AiToolsTestingEmulationUrlsType';
  fail: Scalars['String'];
  pending: Scalars['String'];
  success: Scalars['String'];
};

export type AiToolsUserPackages = {
  __typename?: 'AiToolsUserPackages';
  annual?: Maybe<AiToolsSubscriptionPackageType>;
  annualMinus80?: Maybe<AiToolsSubscriptionPackageType>;
  lifetime?: Maybe<AiToolsSubscriptionPackageType>;
  monthly?: Maybe<AiToolsSubscriptionPackageType>;
  monthlyAfterTrial?: Maybe<AiToolsSubscriptionPackageType>;
  trial?: Maybe<AiToolsSubscriptionPackageType>;
};

export type BrowseerExtResult = {
  __typename?: 'BrowseerExtResult';
  status: StatusType;
  text?: Maybe<Scalars['String']>;
};

export type BrowserExt = {
  __typename?: 'BrowserExt';
  aiAnswerThis: BrowseerExtResult;
  aiCorrectMistakes: BrowseerExtResult;
  aiExplain: BrowseerExtResult;
  aiHumanize: BrowseerExtResult;
  aiSummarize: BrowseerExtResult;
};


export type BrowserExtAiAnswerThisArgs = {
  question: Scalars['String'];
};


export type BrowserExtAiCorrectMistakesArgs = {
  text: Scalars['String'];
};


export type BrowserExtAiExplainArgs = {
  text: Scalars['String'];
};


export type BrowserExtAiHumanizeArgs = {
  text: Scalars['String'];
};


export type BrowserExtAiSummarizeArgs = {
  text: Scalars['String'];
};

export type PasswordChangeCaptchaType = {
  __typename?: 'PasswordChangeCaptchaType';
  /** True once the visitor has to solve a captcha before changing the password */
  isRequired: Scalars['Boolean'];
  /** Google reCAPTCHA site key; empty when the captcha is disabled for the site */
  siteKey: Scalars['String'];
  status?: Maybe<StatusType>;
};

/** This type is used to represent response status of specific type (not found, unauthorized, ...) */
export type StatusType = {
  __typename?: 'StatusType';
  /** Response code (like HTTP response code, but for specific field) */
  code: Scalars['Int'];
  /** Human readable message (not recommended to use in code) */
  message: Scalars['String'];
};

export type TrustpilotReviewCollectorType = {
  __typename?: 'TrustpilotReviewCollectorType';
  businessUnitId?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  iv?: Maybe<Scalars['String']>;
  sig?: Maybe<Scalars['String']>;
  status?: Maybe<StatusType>;
  tag?: Maybe<Scalars['String']>;
};

export type UserDataAiBrainToolsType = {
  __typename?: 'UserDataAiBrainToolsType';
  clientHash: Scalars['String'];
  freePremiumGenAvailableAttempts?: Maybe<Scalars['Int']>;
  hasSubscription?: Maybe<Scalars['Boolean']>;
  status?: Maybe<StatusType>;
  userId?: Maybe<Scalars['Int']>;
};

export type UserDataAiToolsAccessV2Type = {
  __typename?: 'UserDataAiToolsAccessV2Type';
  activeSplitTags?: Maybe<Scalars['String']>;
  clientHash: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  hasAiToolsAccess?: Maybe<Scalars['Boolean']>;
  hasUserEverHadSubscription?: Maybe<Scalars['Boolean']>;
  isAgreeAutoUpgradeEs39123?: Maybe<Scalars['Boolean']>;
  isProFeatureAvailable?: Maybe<Scalars['Boolean']>;
  isSplitEs38751New?: Maybe<Scalars['Boolean']>;
  isSplitEs38799New?: Maybe<Scalars['Boolean']>;
  isSplitEs38934New?: Maybe<Scalars['Boolean']>;
  isSplitEs39123New?: Maybe<Scalars['Boolean']>;
  isSplitEs39222New?: Maybe<Scalars['Boolean']>;
  isTestUser?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  smartCustomerFeedbackKey?: Maybe<Scalars['String']>;
  status?: Maybe<StatusType>;
  subscription?: Maybe<Scalars['Boolean']>;
  trustpilotBusinessUnitId?: Maybe<Scalars['String']>;
  useSafeCopywriting?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['Int']>;
  wordBalance?: Maybe<Scalars['String']>;
  wordBalanceTotal?: Maybe<Scalars['Int']>;
};

export type TrackFreeSmartGenResolverMutationVariables = Exact<{ [key: string]: never; }>;


export type TrackFreeSmartGenResolverMutation = { __typename?: 'AiToolMutation', trackFreeSmartGenResolver: { __typename?: 'StatusType', code: number, message: string } };

export type AiToolsQueryVariables = Exact<{ [key: string]: never; }>;


export type AiToolsQuery = { __typename?: 'AiToolQuery', aiTools: { __typename?: 'AiTools', userDataAiBrainTools: { __typename?: 'UserDataAiBrainToolsType', userId?: number | null, clientHash: string, hasSubscription?: boolean | null, freePremiumGenAvailableAttempts?: number | null, status?: { __typename?: 'StatusType', code: number, message: string } | null } } };


export const TrackFreeSmartGenResolverDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TrackFreeSmartGenResolver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackFreeSmartGenResolver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<TrackFreeSmartGenResolverMutation, TrackFreeSmartGenResolverMutationVariables>;
export const AiToolsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AiTools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiTools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userDataAiBrainTools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"clientHash"}},{"kind":"Field","name":{"kind":"Name","value":"hasSubscription"}},{"kind":"Field","name":{"kind":"Name","value":"freePremiumGenAvailableAttempts"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AiToolsQuery, AiToolsQueryVariables>;